import type { AxiosRequestConfig } from 'axios';
import { api } from '../../axios.instance';

export const deleteMyProfile = (config?: AxiosRequestConfig) => {
  return api.delete('/users/me', config);
};
